import React, { useContext, useState } from "react";
import { connect } from "react-redux";
import { PopupContext, TableContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy } from "../../utils";
import { getDeletePopup } from "../../view/popup/PopupContainer";
import { CardTypes } from "./domainNameCardService"
import { showSuccessToast } from "../../validation/ToastContainer";
import { deleteDomain } from "./domainManagementService";
import { MoreVertical, Edit2, Trash2 } from 'lucide-react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';



function DomainManagementTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    const [deleted, setDeleted] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onEditClick = () => {
        config.showModal({ cardType: CardTypes.EDIT, domainId: data.id, domain: data })
        handleClose();
    }

    const onDeleteClick = () => {
        handleClose();

        setPopup(getDeletePopup(`Are you sure you want to delete the ${data.name} ?`, "Delete Domain", () => {
            deleteDomain(data.id).then(() => {
                showSuccessToast("Domain deleted", "Delete Domain");
                setDeleted(true);
                setConfig({ ...config, lastUpdated: Date.now() })
            })
        }, undefined, "Delete Domain"))
    }

    if (deleted) {
        return null;
    }

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>{data.name}</td>
            <td>{data.kdc}</td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={onEditClick}>
                        <Edit2 className="oct_icon" /> Edit
                    </MenuItem>
                    <MenuItem className="oct_menu-item-v2 oct_menu-item-danger" onClick={onDeleteClick}>
                        <Trash2 className="oct_icon" /> Delete
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    )

}

export default connect()(DomainManagementTableRow);
